import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { NmcNmbiRecordHttpModel } from '../../http/resources/resources-http.models';
import { ErrorResponse } from '../../shared/shared-http.models';

export const NmcNmbiStatusActions = createActionGroup({
  source: 'NMC NMBI Status',
  events: {
    'Load NMC NMBI Status': emptyProps(),
  },
});

export const NmcNmbiStatusAPIActions = createActionGroup({
  source: 'NMC NMBI Status API',
  events: {
    'Loaded NMC Status Successfully': props<{
      nmcStatus: NmcNmbiRecordHttpModel;
    }>(),
    'Loaded NMC Status Unsuccessfully': props<{
      error: ErrorResponse;
    }>(),
    'Loaded NMBI Status Successfully': props<{
      nmbiStatus: NmcNmbiRecordHttpModel;
    }>(),
    'Loaded NMBI Status Unsuccessfully': props<{
      error: ErrorResponse;
    }>(),
  },
});
